import MapStyles from '../../utils/mapUtils/MapStyles'

export default class DtoLayer {
	constructor(obj, type, color = MapStyles.FILL_RED, visibility = true) {
		this.id = obj.id
		this.name = obj.name
		this.code = obj.code
		this.type = type
		this.url = obj.url
		this.opacity = 1
		this.visibility = obj.visibility || obj.visibility === false ? obj.visibility : visibility
		this.color = color
		this.extractStyles = obj.extractStyles ? obj.extractStyles : false
		this.zoom = obj.zoom
		this.updateDate = obj.updateDate
	}
}



// WEBPACK FOOTER //
// ./src/administration/dto/DtoLayer.js